<template>
  <table :class="`table table--clean ${!disableClick ? 'table--hover' : ''} ${noMargin ? '' : 'vertical-offset3'}`">
    <slot />
  </table>
</template>

<script>
export default {
  name: 'TrTable',
  props: {
    disableClick: {
      required: false,
      type: Boolean,
      default: false
    },
    noMargin: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};
</script>
